module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-cf-project-feedback"
  }, [_c('lxm-switch-search', {
    attrs: {
      "searchPlaceholder": '姓名'
    },
    on: {
      "submit": _vm.searchSubmit,
      "end": _vm.searchEnded
    }
  }, [_c('span', {
    staticClass: "lxm-cf-project-feedback__summary-number"
  }, [_vm._v(_vm._s(_vm.state.countSuccess))]), _vm._v(" 次支付成功 \n    "), _vm._v("\n    共计 "), _c('span', {
    staticClass: "lxm-cf-project-feedback__summary-number"
  }, [_vm._v(_vm._s(_vm.amount))])]), _vm._v(" "), _c('lxm-table', {
    attrs: {
      "heads": _vm.tableHeads,
      "rows": _vm.tableRows,
      "tos": _vm.tableTos
    }
  }), _vm._v(" "), (_vm.state.hasMore) ? _c('lxm-more', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.moreClicked
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-20e5b073", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20e5b073!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Cf/Project/Feedback.vue
// module id = 825
// module chunks = 0